module.exports = __webpack_public_path__ + "static/britenites-e19b68e1779a81e84ec7a3e50a6c3b2e.jpg";